import Section from "@/layout/section";
import FAQAccordion from "@/components/faq-accordion";
import { useLanguage } from "@/contexts/LanguageContext";


export default function Section3() {
  const { t } = useLanguage();

  // Get FAQ items from translations
  const faqItems = [
    {
      id: "roi",
      question: t('section3.faq.roi.question'),
      answer: t('section3.faq.roi.answer'),
    },
    {
      id: "trial-demo",
      question: t('section3.faq.trialDemo.question'),
      answer: t('section3.faq.trialDemo.answer'),
    },
    {
      id: "clinics-or-private",
      question: t('section3.faq.clinicsOrPrivate.question'),
      answer: t('section3.faq.clinicsOrPrivate.answer'),
    },
    {
      id: "cost",
      question: t('section3.faq.cost.question'),
      answer: t('section3.faq.cost.answer'),
    },
    {
      id: "security-privacy",
      question: t('section3.faq.securityPrivacy.question'),
      answer: t('section3.faq.securityPrivacy.answer'),
    },
    {
      id: "patient-access",
      question: t('section3.faq.patientAccess.question'),
      answer: t('section3.faq.patientAccess.answer'),
    },
    {
      id: "customization",
      question: t('section3.faq.customization.question'),
      answer: t('section3.faq.customization.answer'),
    },
    {
      id: "integration-details",
      question: t('section3.faq.integrationDetails.question'),
      answer: t('section3.faq.integrationDetails.answer'),
    },
    {
      id: "client-resistance",
      question: t('section3.faq.clientResistance.question'),
      answer: t('section3.faq.clientResistance.answer'),
    },
    {
      id: "custom-features",
      question: t('section3.faq.customFeatures.question'),
      answer: t('section3.faq.customFeatures.answer'),
    },
  ];

  return (
    <>
      <Section
        id="faq"
        title={t('section3.title')}
        description={t('section3.description')}
      >
        <FAQAccordion items={faqItems} />
      </Section>
    </>
  );
}
